/**
 * The thing that follows the cursor during a drag.
 *
 * The browser's own drag image is switched off everywhere in this app, for the
 * reason NitroBoards documented and paid for: a native drag image has platform
 * opacity applied that no CSS of ours can reach, so the card being carried
 * looks washed out no matter what. Drawing our own is the only way it is fully
 * opaque.
 *
 * This is plain DOM rather than a React portal on purpose. The preview lives
 * for the length of one drag inside a container pdnd owns and tears down, and
 * mounting a React root into that container for a few hundred milliseconds
 * would be more machinery than the job needs.
 */

export interface PreviewSpec {
  title: string;
  subtitle: string;
  colour: { solid: string; soft: string };
}

export function drawDragPreview(container: HTMLElement, spec: PreviewSpec): void {
  const card = document.createElement('div');
  card.className = 'drag-preview';
  Object.assign(card.style, {
    width: '150px',
    padding: '6px 9px',
    borderRadius: 'var(--sp-radius-sm)',
    background: spec.colour.soft,
    border: `1px solid ${spec.colour.solid}`,
    borderLeft: `3px solid ${spec.colour.solid}`,
    font: '600 12.5px/1.25 var(--sp-font)',
    color: 'var(--sp-text)',
    pointerEvents: 'none',
  } satisfies Partial<CSSStyleDeclaration>);

  const title = document.createElement('div');
  title.textContent = spec.title;
  title.style.fontWeight = '700';

  const sub = document.createElement('div');
  sub.textContent = spec.subtitle;
  sub.style.fontSize = '11px';
  sub.style.fontWeight = '500';
  sub.style.color = 'var(--sp-text-muted)';

  card.append(title, sub);
  container.appendChild(card);
}
